import { IGeneralApi } from '../types';
import { instance } from './instance';

export const generalApi: IGeneralApi = {
  getAllAddresses: async () => await instance.get('/address/coords/'),

  getLocations: async () => await instance.get(`/location/all/`),

  getGiftCards: async () => await instance.get(`/giftcards/all/`),

  getExcludedLocations: async (params) => {
    const { brandId, branchId } = params;
    let url = '/location/excluded';

    if (!branchId) {
      url += `?brandId=${brandId}`;
    } else if (brandId) {
      url += `?brandId=${brandId}&branchId=${branchId}`;
    }

    return await instance.get(url);
  },

  excludeLocation: async (data) =>
    await instance.post('/location/exclude', data),

  removeExcludedLocation: async (id) =>
    await instance.delete(`/location/excluded/${id}`),

  checkLocationAvailability: async (data) =>
    await instance.post('/location/check-availability', data),
};
